import type { TFunction } from 'i18next';

import type { FeedbackArea, FeedbackCategory, FeedbackStatus } from '@/entities/feedback';

/** The one place that turns stable identifiers into words: list, detail, filters and notifications
    all use these, so a status or a category is never worded two ways. */
export const statusLabel = (t: TFunction, status: FeedbackStatus): string =>
  t(`feedback.status.${status}`);

export const statusHint = (t: TFunction, status: FeedbackStatus): string =>
  t(`feedback.statusHint.${status}`);

export const categoryLabel = (t: TFunction, category: FeedbackCategory): string =>
  t(`feedback.category.${category}`);

export const areaLabel = (t: TFunction, area: FeedbackArea): string => t(`feedback.area.${area}`);

export const MAX_ATTACHMENTS = 5;
export const MAX_ATTACHMENT_BYTES = 10 * 1024 * 1024;

export function formatBytes(bytes: number, locale: string): string {
  const units = ['B', 'KB', 'MB'] as const;
  let value = bytes;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit += 1;
  }
  const digits = unit === 0 ? 0 : value < 10 ? 1 : 0;
  return `${new Intl.NumberFormat(locale, { maximumFractionDigits: digits }).format(value)} ${units[unit]}`;
}
